import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchDoc } from '@shared/index';
import { firstValueFrom } from 'rxjs';

export type UserDocument = SearchDoc & { _id: string };

/** Verwaltet nutzereigene hochgeladene Dokumente. */
@Injectable({
    providedIn: 'root'
})
export class UserDocumentsService {

    private readonly baseUrl = '/api/user/userdocuments';

    constructor(private http: HttpClient) { }

    /**
     * Lädt alle vom Nutzer hochgeladenen Dokumente eines Bots.
     * @param botId ID des Bots.
     * @returns Die hochgeladenen Dokumente.
     */
    public async listDocuments(botId: string): Promise<UserDocument[]> {
        const result = await firstValueFrom(
            this.http.get<{ docs: UserDocument[] }>(`${this.baseUrl}/${botId}`)
        );
        return result.docs;
    }

    /**
     * Lädt ein Dokument des Nutzers hoch.
     * @param botId ID des Bots.
     * @param file Die hochzuladende Datei.
     * @returns Nichts.
     */
    public async uploadDocument(botId: string, file: File): Promise<void> {
        const formData = new FormData();
        formData.append('file', file);
        await firstValueFrom(
            this.http.post<undefined>(`${this.baseUrl}/${botId}/upload`, formData)
        );
    }

    /**
     * Löscht ein hochgeladenes Dokument des Nutzers.
     * @param botId ID des Bots.
     * @param docId ID des zu löschenden Dokuments.
     * @returns Nichts.
     */
    public async deleteDocument(botId: string, docId: string): Promise<void> {
        await firstValueFrom(
            this.http.delete<undefined>(`${this.baseUrl}/${botId}/${docId}`)
        );
    }

    /**
     * Gibt die erlaubten Dateitypen für Nutzer-Uploads zurück.
     * @returns Liste der erlaubten Dateitypen.
     */
    public async getAllowedTypes(): Promise<string[]> {
        const result = await firstValueFrom(
            this.http.get<string[]>(`${this.baseUrl}/allowedtypes`)
        );
        return result;
    }
}
